import Cookies from 'js-cookie'
import store from 'src/vuex/store.js'
import Router from 'vue-router'
import Vue from 'vue'

import DashboardLayout from 'src/layout/DashboardLayout.vue'
// Auth
import Login from 'src/pages/Auth/Login.vue'

// GeneralViews
import NotFound from 'src/pages/NotFoundPage.vue'
import Overview from 'src/pages/Overview.vue'
import UserProfile from 'src/pages/UserProfile.vue'
import ServiceDetail from 'src/pages/ServiceDetail.vue'
Vue.use(Router)

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/login'
  },
  {
    path: '/login',
    component: Login,
    children: [
      {
        path: '/login',
        name: 'login',
        component: Login
      }
    ]
  },
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'service/:id',
        name: 'ServiceDetail',
        component: ServiceDetail
      },
      {
        path: 'profile',
        name: 'UserProfile',
        component: UserProfile
      }
    ]
  },
  { path: '*', component: NotFound }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  console.log('accediendo')
  const accessToken = Cookies.get('access_token')

  if (accessToken) {
    if (
      to.matched.some((record) => record.meta.requiresAuth) &&
      !store.state.status &&
      !accessToken
    ) {
      alert('Please, sign in to continue')
      next('/login')
    } else if (store.state.status && accessToken) {
      console.log('logged')
      next('/admin/overview')
    } else {
      console.log('Next')
      next()
    }
  } else {
    console.log('TOKEN NOT FOUND')
    console.log(to.name)
    console.log(from.name)
    if (to.name != 'login') {
      next('/login')
    } else {
      next()
    }
  }
})

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default router
